import "./footer.scss";

export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer__text">پلتفرم هوشمند مدرسه مدادرنگی ۱۴۰۵</p>
    </footer>
  );
}
